import React from "react";
import {Drawer, Grid, Typography, IconButton} from "@mui/material";
import theme from "../../../theme/Theme";
import cancel from "../../../../public/assets/icons/cancel.svg";

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    subtitle?: string;
    children: React.ReactNode;
}

const SettingsDrawer: React.FC<IProps> = ({
                                              isOpen,
                                              onClose,
                                              title,
                                              subtitle,
                                              children
                                          }) => {
    return (
        <Drawer
            ModalProps={{
                container: () => {
                    return document.getElementById("fullscreenPortal") as HTMLElement;
                },
                style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                },
            }}
            PaperProps={{style: {position: "absolute", margin: "20px"}}}
            SlideProps={{
                onExiting: (node) => {
                    node.style.webkitTransform = "scaleX(0)";
                    node.style.transform = "scaleX(0)";
                    node.style.transformOrigin = "top left ";
                },
            }}
            anchor="top"
            open={isOpen}
            onClose={onClose}
        >
            <Grid container>
                <Grid item container margin={"20px"}>
                    <Grid item xs={6}>
                        <Typography variant="h2">
                            {title}
                            {subtitle && (
                                <>
                                    <span> /</span>
                                    <span style={{color: theme.palette.artisticTextHigh.main}}>
                                        {" "}
                                        {subtitle}
                                    </span>
                                </>
                            )}
                        </Typography>
                    </Grid>
                    <Grid item xs={6} display={"flex"} justifyContent={"flex-end"}>
                        <IconButton onClick={onClose}>
                            <img
                                src={cancel}
                                alt="close settings"
                                style={{height: "20px"}}
                            />
                        </IconButton>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    {children}
                </Grid>
            </Grid>
        </Drawer>
    );
};

export default SettingsDrawer;